import { ReduxKit } from '@team/redux';

const domain = 'i18n-saga-adapter';

export const eventNamed = ReduxKit.eventNameBuilder(domain);
